var getConceptSettings = function getConceptSettings(concept) {
  var checkedConcept = concept ? concept.toLowerCase() : '';
  switch (checkedConcept) {
    case 'sunwing':
    case 'sunwingfamilyresorts':
      {
        return {
          altText: 'Sunwing',
          key: 'sunwing',
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'sunprime':
    case 'sunprimehotels':
      {
        return {
          altText: 'Sunprime',
          key: 'sunprime',
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'oceanbeachclub':
    case 'obcbysunwing':
    case 'ocean beach club':
      {
        return {
          altText: 'Ocean Beach Club',
          key: 'obc',
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'familygarden':
      {
        return {
          altText: 'Family Garden',
          key: 'family-garden',
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'sport':
      {
        return {
          altText: 'Sport',
          key: 'sport',
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'activeselection':
      return {
        altText: 'Active Selection',
        key: 'active-selection',
        desktopSize: 44,
        mobileSize: 44 * 0.65
      };
    case 'adultonlyselection':
      return {
        altText: 'Adults Only Selection',
        key: 'adults-only-selection',
        desktopSize: 47,
        mobileSize: 47 * 0.65
      };
    case 'cityfavouriteselection':
      return {
        altText: 'City Favourite Selection',
        key: 'city-favourite-selection',
        desktopSize: 49,
        mobileSize: 49 * 0.65
      };
    case 'familyselection':
      return {
        altText: 'Family Selection',
        key: 'family-selection',
        desktopSize: 42,
        mobileSize: 42 * 0.65
      };
    case 'golfselection':
      return {
        altText: 'Golf Selection',
        key: 'golf-selection',
        desktopSize: 41,
        mobileSize: 41 * 0.65
      };
    case 'hideawayselection':
      return {
        altText: 'Hideaway Selection',
        key: 'hideaway-selection',
        desktopSize: 45,
        mobileSize: 45 * 0.65
      };
    case 'nordicfavouriteselection':
    case 'nordic selection':
    case 'nordicselection':
    case 'nordicfavourites':
    case 'nordiskafavoriter':
    case 'pohjoismaisetsuosikit':
    case 'nordiskefavoritter':
      return {
        altText: 'Nordic Favourite Selection',
        key: 'nordic-favourite-selection',
        desktopSize: 51,
        mobileSize: 51 * 0.65
      };
    case 'popularselection':
      return {
        altText: 'Popular Selection',
        key: 'popular-selection',
        desktopSize: 43,
        mobileSize: 43 * 0.65
      };
    case 'romanticselection':
      return {
        altText: 'Romantic Selection',
        key: 'romantic-selection',
        desktopSize: 45,
        mobileSize: 45 * 0.65
      };
    case 'topselection':
    case 'topselectionfamily':
    case 'topselectionadult':
    case 'topselectionothers':
    case 'signature':
    case 'signature_t':
    case 'topselectionother':
    case 'topselectionförvuxna':
    case 'topselectionforvoksne':
    case 'topselectionaikuisille':
    case 'topselectionförfamiljer':
    case 'topselectionforfamilier':
    case 'topselectionforfamilien':
    case 'topselectionperheille':
    case 'topselectionföralla':
    case 'topselectionforalle':
    case 'topselectionkaikille':
      return {
        altText: 'Top Selection',
        key: 'top-selection',
        desktopSize: 39,
        mobileSize: 39 * 0.65
      };
    case 'uniqueselection':
      return {
        altText: 'Unique Selection',
        key: 'unique-selection',
        desktopSize: 43,
        mobileSize: 43 * 0.65
      };
    case 'smallandfriendlyselection':
    case 'small&friendlyselection':
    case 218:
      return {
        altText: 'Small and Friendly Selection',
        key: 'small-friendly-selection',
        desktopSize: 49,
        mobileSize: 49 * 0.65
      };
    default:
      {
        return null;
      }
  }
};

export { getConceptSettings };
//# sourceMappingURL=utils.js.map
